import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'

import cx from 'classnames'

import { TimelineEventsFeed } from 'components/AccountDrawer/ActivityFeed'
import { CurrentUserContext } from 'context/currentUserContext'
import { AccountDetailsPageParams } from 'pages/CCRMAccountDetailsPage'
import { Timeline } from 'typings/timeline'
import { segmentTrack, TrackType } from 'utils/tracking'

import MostRecentChatSection from '../MostRecentChatSection'

import styles from './styles.module.css'

interface FeedTabProps {
  mostRecentChat: Timeline | undefined
}

const FeedTab = (props: FeedTabProps) => {
  const { mostRecentChat } = props
  const { id: endUserId } = useParams<AccountDetailsPageParams>()

  const currentUser = useContext(CurrentUserContext)
  const trackAction = (action: string, additionalData?: any) => {
    segmentTrack(TrackType.ACTIVITY_TIMELINE_ACTION, {
      userId: currentUser?.id,
      orgId: currentUser?.orgId,
      action,
      page: 'ContactDetailsPage',
      ...additionalData
    })
  }

  return (
    <>
      <div
        className={cx(styles.leftSide, {
          [styles.leftSideWithOutChat]: Boolean(!mostRecentChat)
        })}>
        <div className={styles.feedContainer}>
          <TimelineEventsFeed
            contactId={endUserId}
            trackAction={trackAction}
            inDrawer={false}
            scrollTargetId="contactDetailsPage"
          />
        </div>
      </div>
      {mostRecentChat && (
        <div className={styles.rightSide}>
          <MostRecentChatSection mostRecentChat={mostRecentChat} />
        </div>
      )}
    </>
  )
}

export default FeedTab
